import { Box, Container, Divider, Typography } from "@mui/material";
import { t } from "i18next";
import CustomInput from "../components/customComponent/CustomInput";
import { useState, useEffect } from "react";
import { Navigate, useLocation, useNavigate, useParams } from "react-router-dom";
import "../styles/inputStyle.css";
import CustomButton from "../components/customComponent/CustomButton";
import SelectTrainType from "../components/train/SelectTrainType";
import SelectDataset from "../components/train/SelectDataset";
import { addTrain, createTrain, getTrain } from "../services/trainService";
import SelectTrainCycle from "../components/train/SelectTrainCycle";
import { getChangedValues } from "../utils/trainUtil";
import { importAIModules } from "common-lib";
import { toast } from "react-toastify";
import ServerSelectModal from "../components/train/ServerSelectModal.js";

interface CreateTrainForm {
  name: string;
  description: string;
  dataSet_uuid?: string;
  image_period?: number;
  material_name?: string;
  trainModel_id: number | null;
  inspModel_id: number | null;
  inspModel_uuid?: string | null;
  options: string;
  pre_process: string;
  post_process: string;
}

export default function TrainCreatePage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState<CreateTrainForm>({
    name: "",
    description: "",
    trainModel_id: null,
    inspModel_id: null,
    inspModel_uuid: null,
    options: "{}",
    pre_process: "[]",
    post_process: "{}",
  });
  const [selectedTrainModel, setSelectedTrainModel] = useState(null);
  const [selectedInspModel, setSelectedInspModel] = useState(null);
  const [selectedDataset, setSelectedDataset] = useState(null);
  const [selectDatasetType, setSelectDatasetType] = useState("db");
  const [selectTrainType, setSelectTrainType] = useState("new");
  const [initialFormData, setInitialFormData] = useState({});
  const [thirdTrainOption, setThirdTrainOption] = useState(false);
  const [selectedServer, setSelectedServer] = useState<string | null>(null);
  const [showSelectModal, setShowSelectModal] = useState(false);
  const [time, setTime] = useState({
    period: "monthly",
    week: "1",
    weekday: "monday",
    exe: "00:00",
  });

  useEffect(() => {
    const fetchTrainData = async () => {
      try {
        if (id) {
          const detailResponse = await getTrain(Number(id));
          const data = detailResponse.data;
          console.log("data", data);

          const trainCondition = JSON.parse(data.train_condition);
          const dataSet = data.dataSet;
          // console.log("trainCondition", data.inspModel ? "continue" : "new");
          setSelectedTrainModel(data.trainModel);
          setSelectedInspModel(data.inspModel);
          setSelectDatasetType(data.dataSet.id ? "db" : "condition");
          setSelectTrainType(data.inspModel ? "continue" : "new");

          const detailData = {
            name: data.name,
            description: data.description,
            trainModel_id: data.trainModel?.id,
            inspModel_id: data.inspModel?.id,
            dataSet: dataSet.id ? dataSet : null,
            image_period: dataSet.id ? "" : dataSet.image_period,
            material_name: dataSet.id ? "" : dataSet.material_name,
            options: data.options,
            pre_process: data.pre_process,
            post_process: data.post_process,
          };
          setThirdTrainOption(trainCondition.time && "period" in trainCondition.time);
          setFormData(detailData);
          setInitialFormData(detailData);
          setTime(trainCondition.time);
        }
      } catch (error) {
        console.error("Data initialization failed:", error);
      }
    };
    fetchTrainData();
  }, [id]);

  useEffect(() => {
    if (!selectedServer) return;
    // console.log("selectedServer", selectedServer);
    handleSubmit();
    setSelectedServer(null);
  }, [selectedServer]);

  const updateFormData = (field: string, value: string) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSelectModalOpen = () => {
    setShowSelectModal(true);
  };

  const handleSelectModalClose = () => {
    setShowSelectModal(false);
  };

  const handleSubmit = async () => {
    try {
      if (!id) {
        const changedData = getChangedValues(
          formData,
          initialFormData,
          thirdTrainOption,
          time,
          selectTrainType,
          selectedInspModel,
          selectedTrainModel,
          selectDatasetType,
          selectedDataset,
        );
        // console.log("changedData", changedData);
        const response = await addTrain(changedData);
        const parsedOptions = JSON.parse(formData.options);
        if (response.data.uuid && String(response.data.train_condition.type || "").startsWith("stsup")) {
          await importAIModules(
            response.data.uuid,
            false,
            false,
            false,
            {
              ip: selectedServer,
            },
            parsedOptions.AI_Vision,
            formData.inspModel_uuid,
          );
        }
        // console.log("response", response);
        setSelectedServer(null);
        navigate("/home", { state: { tab: "train_list" } });
      } else {
        // const changedData = getChangedValues();
        // await editTrain(id, changedData);
        // navigate("/train");
      }
    } catch (error) {
      console.error("error", error);
      toast.error(String(error));
      // toast.error(error.response?.data?.message || "학습 등록에 실패했습니다.");
    }
  };

  return (
    <Container
      component="main"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        // height: "80vh",
        mt: 3,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "900px",
          // height: "680px",
          border: "1px solid var(--dk-border, #ccc)",
          borderRadius: "6px",
          backgroundColor: "var(--secondary-bg-color)",
        }}
      >
        {/* <div className="p-8 bg-gradient-to-r from-blue-600 to-indigo-600"> */}
        <div className="p-8 bg-blue-400">
          <h1 className="mb-2 text-3xl font-bold text-white">{t("CreateTrain")}</h1>
          <p className="text-blue-100">모델과 데이터셋을 설정하여 새로운 학습을 생성하세요.</p>
        </div>
        <div className="p-8 space-y-2">
          {/* <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              width: "100%",
              height: "100%",
            }}
          > */}
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <CustomInput
              required={true}
              subTitle={t("TrainName")}
              value={formData.name}
              setValue={(value) =>
                setFormData((prev) => ({
                  ...prev,
                  name: value as string,
                }))
              }
              width="100%"
            />
            <CustomInput
              required={true}
              subTitle={t("Description")}
              value={formData.description}
              setValue={(value) =>
                setFormData((prev) => ({
                  ...prev,
                  description: value as string,
                }))
              }
              width="100%"
            />
          </Box>
          <SelectTrainType
            formData={formData}
            updateFormData={updateFormData}
            selectedTrainModel={selectedTrainModel}
            selectedInspModel={selectedInspModel}
            setSelectedTrainModel={setSelectedTrainModel}
            setSelectedInspModel={setSelectedInspModel}
            selectTrainType={selectTrainType}
            setSelectTrainType={setSelectTrainType}
          />

          <SelectDataset
            formData={formData}
            updateFormData={updateFormData}
            // datasetList={datasetList}
            selectDatasetType={selectDatasetType}
            setSelectDatasetType={setSelectDatasetType}
            selectedDataset={selectedDataset}
            setSelectedDataset={setSelectedDataset}
          />

          <SelectTrainCycle
            thirdTrainOption={thirdTrainOption}
            setThirdTrainOption={setThirdTrainOption}
            time={time}
            setTime={setTime}
            selectTrainType={selectTrainType}
            selectDatasetType={selectDatasetType}
          />
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
            <CustomButton text={t("Save")} variant="contained" onClick={handleSelectModalOpen} />
          </Box>
        </div>
      </Box>
      {showSelectModal && (
        <ServerSelectModal
          open={showSelectModal}
          onClose={handleSelectModalClose}
          setSelectedServer={setSelectedServer}
          changeMode={false}
          nowServer={null}
        />
      )}
    </Container>
  );
}
